import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import IconButton from '@mui/material/IconButton';
// import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
//import { AccountPicker } from "./AccountPicker";
import { Avatar } from 'primereact/avatar';

export const LogoutButton = () => {
    const { instance, accounts } = useMsal();
    const [accountSelectorOpen, setOpen] = useState(false);
    const [name, setName] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
    const activeAccount = instance.getActiveAccount();
    useEffect(() => {
        if (activeAccount && activeAccount.name) {
            let nameSplit = activeAccount.name.split(' ');
            setName(nameSplit.length > 1 ? (nameSplit[0][0] + nameSplit[1][0]) : nameSplit[0][0]);
        } else {
            setName(null);
        }
    }, [activeAccount]);


    // Extract the user's name from the ID token claims
    const userName = accounts[0]?.name || "User";
    // Convert the user's name to initials (e.g., "John Doe" -> "JD")
    const userInitials = userName
    .split(" ")
    .map((name) => name[0])
    .join("")
    .toUpperCase();

    console.log("user intials", userInitials);
    const handleLogout = (logoutType) => {
        setAnchorEl(null);

        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/atsg/home"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/atsg/home"
            });
        }
    }

    const handleAccountSelection = () => {
        setAnchorEl(null);
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton
                onClick={(event) => setAnchorEl(event.currentTarget)}
                color="inherit"
            >
                {/* <AccountCircle /> */}
                {/* Avator holding username initials. */}
                <Avatar label={userInitials}  shape="circle" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                {/*<MenuItem onClick={() => handleAccountSelection()} key="switchAccount">Switch Account</MenuItem> */}
                {/* <MenuItem onClick={() => handleLogout("popup")} key="logoutPopup">Logout using Popup</MenuItem> */}
                <MenuItem onClick={() => handleLogout("redirect")} key="logoutRedirect">Logout</MenuItem>
            </Menu>
           {/* <AccountPicker open={accountSelectorOpen} onClose={handleClose} /> */}
        </div>
    )
};